import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";
import { GridLogicOperator } from "@mui/x-data-grid-pro";
import {ShepPagination, ShepDataGridPro, ShepCheckbox, ShepTooltip} from "@/components/GenericComponents/ShepComponents";

//http://confluence.edisoft.com:8090/x/pjqWB

const PopUpDataGrid = forwardRef((props, ref) => {
  // Remove useGridApiRef and DataGridPro import, as ShepDataGridPro is used
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
    logicOperator: GridLogicOperator.And,
  });
  const [selectionModel, setSelectionModel] = useState([]);

  useImperativeHandle(ref, () => ({
    getGridFilter() {
      return gridFilterModel;
    },
    setGridFilter(newFilterModel) {
      setGridFilterModel(newFilterModel);
    },
    setSelection(selectionModel) {
      setSelectionModel(selectionModel);
    },
  }));

  const onChangeRowSelection = (newModel) => {
    if (props.forceDisableMultipleSelection)
      setSelectionModel(
        (newModel = newModel.filter((newId) => !selectionModel.includes(newId)))
      );
    else setSelectionModel(newModel);
  };

  useEffect(() => {
    // If ShepDataGridPro exposes a way to get selected rows, adapt here
    if (props.onSelectedRowsChange) props.onSelectedRowsChange(selectionModel);
  }, [selectionModel]);

  useEffect(() => {
    setSelectionModel([]);
  }, [props.rows]);

  // Styles similar to gridHeaderSx from Notifications.js
  const gridHeaderSx = {
    "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader:hover": {
      borderBottomLeftRadius: "4px",
      borderBottomRightRadius: "4px",
      backgroundColor: "var(--primary-pale)",
      borderBottom: "none",
      borderLeft: "none",
    },
    color: "var(--text-primary)",
    fontSize: "var(--font-sm)",
    fontFamily: "var(--font-family)",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    backgroundColor: "var(--default-light)",
    border: "none",
    "& .MuiDataGrid:hover": {
      backgroundColor: "inherit",
    },
    "& .MuiDataGrid-cellCheckbox, & .workflow-row": {
      opacity: 0,
      borderBottom: "none",
    },
    "& .MuiDataGrid-cell": {
      borderBottom: "none",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "var(--tertiary-13)",
    },
    "& .workflow-row:hover": {
      backgroundColor: "transparent",
    },
    "& .Mui-selected": {
      backgroundColor: "var(--primary-pale)",
    },
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader.MuiDataGrid-columnHeaderCheckbox":
      {
        outline: "none",
      },
    "& .MuiDataGrid-row:hover .MuiDataGrid-cellCheckbox, & .MuiDataGrid-row:hover .workflow-row":
      {
        opacity: 1,
      },
    "& .MuiDataGrid-cellCheckbox": {
      borderLeft: "8px solid transparent",
    },
    "& .Mui-selected .MuiDataGrid-cellCheckbox": {
      opacity: 1,
      borderLeft: "8px solid var(--primary-main)",
      borderTopLeftRadius: "4px",
      borderBottomLeftRadius: "4px",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontSize: "var(--font-md)",
      fontWeight: "var(--font-bold)",
      borderLeft: "none",
    },
    "& .MuiCheckbox-root": {
      display: "block",
      paddingBottom: "20px",
    },
  };

  return (
    <ShepDataGridPro
      className="PopUpDataGrid"
      isDataLoaded={!!props.rows}
      rows={props.rows}
      columns={props.columns.map((value) => {
        let tempData = { ...value };
        tempData.editable = false;
        tempData.hideable = false;
        return tempData;
      })}
      slots={{
        pagination: ShepPagination,
        baseCheckbox: ShepCheckbox,
        baseTooltip: ShepTooltip,
      }}
      initialState={Object.assign(props.initialState ?? "", {
        pagination: {
          paginationModel: {
            pageSize: 5,
          },
        },
      })}
      pagination={props.pagination ?? true}
      pageSizeOptions={[5, 10, 25]}
      disableColumnMenu
      disableColumnReorder={true}
      disableColumnResize={true}
      rowHeight={props.rowHeight ?? 55}
      columnHeaderHeight={props.columnHeaderHeight ?? 55}
      checkboxSelection={props.checkboxSelection ?? false}
      sx={gridHeaderSx}
      filterModel={gridFilterModel}
      onFilterModelChange={(newFilterModel) => {
        setGridFilterModel(newFilterModel);
      }}
      rowSelectionModel={selectionModel}
      onRowSelectionModelChange={onChangeRowSelection}
    />
  );
});

export default PopUpDataGrid;
// export { GridLogicOperator, RenderStatus };
